module.exports = __webpack_public_path__ + "img/team-leader.9428bda6.svg";